import { render, staticRenderFns } from "./DisplayField.vue?vue&type=template&id=73b92e04&scoped=true&"
import script from "./DisplayField.vue?vue&type=script&lang=js&"
export * from "./DisplayField.vue?vue&type=script&lang=js&"
import style0 from "./DisplayField.vue?vue&type=style&index=0&id=73b92e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b92e04",
  null
  
)

export default component.exports